var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('atom-label',{attrs:{"tag":"h2","text":"Scheduled"}}),_vm._v(" "),_c('molecule-list',{attrs:{"items":_vm.tracks}},[_c('atom-icon',{attrs:{"slot":"left","icon":"clock","color":"red"},slot:"left"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }